/**
 * Community Leaderboard master-specific translation keys
 */
export const communityLeaderboard = {
  list: {
    main_heading: "admin.community_leaderboard_list_heading",
    scope_filter: {
      city: "admin.community_leaderboard_scope_city",
      country: "admin.community_leaderboard_scope_country",
      global: "admin.community_leaderboard_scope_global",
    },
    table: {
      rank_col_heading: "admin.community_leaderboard_table_rank_col_heading",
      user_name_col_heading: "admin.community_leaderboard_table_user_name_col_heading",
      email_col_heading: "admin.community_leaderboard_table_email_col_heading",
      city_col_heading: "admin.community_leaderboard_table_city_col_heading",
      country_col_heading: "admin.community_leaderboard_table_country_col_heading",
      total_successful_referrals_col_heading: "admin.community_leaderboard_table_total_successful_referrals_col_heading",
      action_col_heading: "admin.community_leaderboard_table_action_col_heading",
    },
    view_tooltip: "admin.community_leaderboard_view_tooltip",
    no_referral_tooltip: "admin.community_leaderboard_no_referral_tooltip",
    defaults: {
      na: "admin.community_leaderboard_defaults_na",
    },
  },
};
